var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// - Import app components
import UserBox from 'components/userBox';
// - Import API
// - Import actions
/**
 * Create component class
 */
var UserBoxListComponent = /** @class */ (function (_super) {
    __extends(UserBoxListComponent, _super);
    function UserBoxListComponent(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Component constructor
         * @param  {object} props is an object properties of component
         */
        _this.userBoxList = [];
        _this.userList = function () {
            var uid = _this.props.uid;
            var users = _this.props.users;
            if (users) {
                users.forEach(function (user, key) {
                    if (uid !== key) {
                        _this.userBoxList.push(React.createElement(UserBox, { key: key, userId: key, user: user }));
                    }
                });
            }
            return _this.userBoxList;
        };
        // Defaul state
        _this.state = {
            width: 0
        };
        return _this;
        // Binding functions to `this`
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    UserBoxListComponent.prototype.render = function () {
        var styles = {};
        var W = this.userBoxList.length * 20;
        // alert(this.userBoxList.length)
        return (React.createElement("div", { style: { display: 'flex', overflow: 'auto', whiteSpace: 'nowrap', textAlign: 'center', backgroundColor: 'white' } }, this.userList()));
    };
    UserBoxListComponent.propTypes = {
        /**
         * List of users
         */
        users: PropTypes.object
    };
    return UserBoxListComponent;
}(Component));
export { UserBoxListComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var uid = state.getIn(['authorize', 'uid'], 0);
    return {
        uid: uid
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(UserBoxListComponent);



//////////////////
// WEBPACK FOOTER
// ./src/components/userboxlist2/UserBoxListComponent2.tsx
// module id = 1563
// module chunks = 0 1 2 3